import {
  SSO_TOKEN_KEY,
  SSO_ERROR_KEY,
  PROVIDERS,
  SSO_ERROR_EMAIL,
} from "modules/auth/constants";
import { PageLoader } from "@remo-co/ui-core/src/components/PageLoader";
import { useEffect } from "react";
import { useParams } from "react-router";
import { getLinkedInTokenApi } from "modules/auth/auth.api";
import useQueryParams from "modules/queryParams/hooks/useQueryParams";
import { getCallbackUrl } from "modules/auth/utils/signInWithProvider/signInWithProvider";
import { useI18n } from "i18n";
import { PAGES, usePageTracking } from "modules/tracking";

interface Params {
  providerName: PROVIDERS;
}

const retrieveLinkedinTokenAndProceed = async (
  code: string,
  state: string,
  redirectTo: string,
) => {
  const response = await getLinkedInTokenApi(code, state, redirectTo);

  if (response.token) {
    localStorage.setItem(SSO_TOKEN_KEY, response.token);
    window.close();
  }

  localStorage.setItem(SSO_ERROR_KEY, response.message ?? "");
  localStorage.setItem(SSO_ERROR_EMAIL, response.email ?? "");
  window.close();
};

const Callback = () => {
  const { t } = useI18n(["common"]);
  const { token, error, code, state, redirectTo, fromLinkedinRedirect } =
    useQueryParams();
  const { providerName } = useParams<Params>();

  usePageTracking(PAGES.SSO_REDIRECT, {
    metadata: {
      provider: providerName,
    },
  });

  useEffect(() => {
    if (providerName === PROVIDERS.LINKEDIN && !error) {
      if (!code || !state) {
        return;
      }

      if (redirectTo) {
        // custom domain sso flow - our linkedin endpoint will return `redirectTo`
        window.location.replace(
          `${redirectTo}?code=${code}&state=${state}&fromLinkedinRedirect=true`,
        );
        return;
      }

      retrieveLinkedinTokenAndProceed(
        code.toString(),
        state.toString(),
        fromLinkedinRedirect === "true" ? getCallbackUrl(providerName) : "",
      );
    }

    if (error) {
      localStorage.setItem(SSO_ERROR_KEY, error.toString());
      window.close();

      return;
    }

    if (token) {
      localStorage.setItem(SSO_TOKEN_KEY, token.toString());
      window.close();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PageLoader message={t("loading")} />;
};

export default Callback;
